module.exports = __webpack_public_path__ + "img/request.7bcd0644.svg";